import { l as logger } from "../../../../../../../../../chunks/logger.js";
import { g as getMongo } from "../../../../../../../../../chunks/mongo.js";
const load = async ({ params, depends }) => {
  depends("app:sharding");
  const shardingPromise = (async () => {
    try {
      const mongo = await getMongo();
      const data = await mongo.getShardingInfo(params.server, params.database, params.collection);
      return { data, error: null };
    } catch (err) {
      logger.error("Error fetching sharding info:", err);
      return {
        data: null,
        error: `Failed to fetch sharding info: ${err instanceof Error ? err.message : String(err)}`
      };
    }
  })();
  return {
    sharding: shardingPromise
  };
};
export {
  load
};
